define('presentation/common/callDetails/presentationObjects/callDetailsPresentationObject',[],function() {
    return function(){
        const self = this;

        self.callId = null;
        self.firstCallDetailStep = null;
        self.callDetailSteps = null;
        self.callerLocation = null;
        self.calleeLocation = null;
        self.voicemail = null;
        self.recording = null;
        self.receptionistMessage = null;
        self.webChat = null;
        self.mapUrl = null;
    };
});

